import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=c5f97f92&scoped=true"
import script from "./LegalNotice.vue?vue&type=script&lang=ts"
export * from "./LegalNotice.vue?vue&type=script&lang=ts"
import style0 from "./LegalNotice.vue?vue&type=style&index=0&id=c5f97f92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f97f92",
  null
  
)

export default component.exports